import React from 'react';
import IphoneIcon from '../../../icons/IPhone13.svg?react';
import style from './style.module.scss';

interface PageProps {
    backgroundColor?: string;
    children?: React.ReactNode;
}

// Inline SVGs replace the previous emoji glyphs (📶 📡 🔋) in the
// simulated status bar. Inlining keeps the icons visually consistent
// with the rest of the preview chrome regardless of which OS-level
// emoji font the CMS user has, and lets us color them via CSS
// `currentColor`.

const SignalIcon = () => (
    <svg
        width="16"
        height="11"
        viewBox="0 0 16 11"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <rect x="0" y="8" width="2.5" height="3" rx="0.5" />
        <rect x="4" y="6" width="2.5" height="5" rx="0.5" />
        <rect x="8" y="3" width="2.5" height="8" rx="0.5" />
        <rect x="12" y="0" width="2.5" height="11" rx="0.5" />
    </svg>
);

const WifiIcon = () => (
    <svg
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path d="M8 12a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z" />
        <path d="M3.6 7.7a6 6 0 0 1 8.8 0l-1.1 1.1a4.5 4.5 0 0 0-6.6 0L3.6 7.7Z" />
        <path d="M1.5 5.4a9 9 0 0 1 13 0L13.4 6.5a7.5 7.5 0 0 0-10.8 0L1.5 5.4Z" />
        <path d="M0 3.2a12 12 0 0 1 16 0l-1.1 1.1a10.5 10.5 0 0 0-13.8 0L0 3.2Z" />
    </svg>
);

const BatteryIcon = () => (
    <svg
        width="24"
        height="12"
        viewBox="0 0 24 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <rect
            x="0.5"
            y="0.5"
            width="20"
            height="11"
            rx="2.5"
            stroke="currentColor"
            fill="none"
            opacity="0.5"
        />
        <rect
            x="22"
            y="4"
            width="1.5"
            height="4"
            rx="0.5"
            fill="currentColor"
            opacity="0.5"
        />
        <rect x="2" y="2" width="17" height="8" rx="1.5" fill="currentColor" />
    </svg>
);

export const Acvt = ({ backgroundColor, children }: PageProps) => {
    return (
        <div
            className={style.iphone}
            style={{ backgroundColor: backgroundColor }}
        >
            {/* Status bar: 9:41 + cellular / wi-fi / battery glyphs */}
            <div className={style.status_bar}>
                <span className={style.time}>9:41</span>
                <div className={style.status_icons}>
                    <SignalIcon />
                    <WifiIcon />
                    <BatteryIcon />
                </div>
            </div>

            {children}

            <div className={style.iphone_home_bar}>
                <span className={style.swipe_bar}></span>
            </div>

            <IphoneIcon />
        </div>
    );
};
